import { render } from "./app.html?vue&type=template&id=01ddea2c&scoped=true&ts=true&external"
import script from "./app.ts?vue&type=script&lang=ts&external"
export * from "./app.ts?vue&type=script&lang=ts&external"

import "./app.scss?vue&type=style&index=0&id=01ddea2c&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ddea2c"]])

export default __exports__